/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import {
  useGetByoaSubscriptionRequestsToUser,
  usePatchByoaSubscriptionRequest,
} from "../../../api/requests";
import RequestCard from "../RequestCard";
import Notification from "../../../components/Notification";
import { toKebabCase } from "../../../utils/helperFunctions";
import { REQUEST_VIEWS } from "../../../utils/constants";
import styles from "../styles";

const getRequestsParams = (view) => `/${toKebabCase(view)}`;

const REQUEST_CARD_KEYS = (view) => [
  view === REQUEST_VIEWS.requestsReceived
    ? { key: "requester", name: "Requested By" }
    : { key: "approver", name: "Requested To" },
  { key: "subscriptionName", name: "Name" },
  { key: "tenantUrl", name: "Tenant" },
  { key: "cloudType", name: "Cloud" },
];

const ByoaSubscriptions = ({
  view,
  setConfirmationDialog,
  requestFilter,
  refreshToggle,
  setRefreshToggle,
}) => {
  const [notify, setNotify] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("");

  const [requests, setRequests] = useState([]);

  const {
    postData: getRequests,
    response: getRequestsResp,
    isLoading: isLoadingRequests,
  } = useGetByoaSubscriptionRequestsToUser();

  const {
    postData: patchRequest,
    response: patchRequestResp,
    responseStatus: patchRequestsRespStatus,
  } = usePatchByoaSubscriptionRequest();

  useEffect(() => {
    const message =
      patchRequestResp?.message ||
      patchRequestResp?.detail?.message ||
      patchRequestResp?.detail;
    if (message?.length && typeof patchRequestsRespStatus === "number") {
      setMessage(message);
      setSeverity(patchRequestsRespStatus === 200 ? "success" : "error");
      setNotify(true);
    }
    setRefreshToggle((prev) => !prev);
  }, [patchRequestResp, patchRequestsRespStatus]);

  useEffect(() => {
    getRequests(getRequestsParams(view));
  }, [refreshToggle, view]);

  useEffect(() => {
    if (getRequestsResp?.response) {
      setRequests(getRequestsResp?.response);
    }
  }, [getRequestsResp]);

  const handleRequestApproval = (status, id) => {
    setConfirmationDialog({
      isOpen: true,
      content: `You are going to mark this request as ${status}`,
      handleDialogConfirm: () => {
        patchRequest({ status: status }, `/${id}`);
      },
    });
  };

  const requestCards = requests
    ?.map((request, i) => {
      return (
        requestFilter?.[request?.status] && (
          <RequestCard
            key={i}
            view={view}
            request={request}
            handleRequestApproval={handleRequestApproval}
            requestCardKeys={REQUEST_CARD_KEYS}
          />
        )
      );
    })
    .filter(Boolean);
  return (
    <div style={{ width: "100%" }}>
      <Notification
        notify={notify}
        severity={severity}
        setNotify={setNotify}
        message={message}
      />
      {requestCards?.length && !isLoadingRequests ? (
        <Box sx={styles.requestCardsParentGrid}>{requestCards}</Box>
      ) : (
        <Typography>No Requests</Typography>
      )}
    </div>
  );
};

export default ByoaSubscriptions;
